<template>
    <AppForm
        v-if="loaded"
        :loading="loading"
        :is-new="isNew"
        :heading="heading"
        @submit="submitHandler"
    >
        <template v-slot:main>
            <FormGroup
                v-for="locale in locales"
                :key="locale"
                :flag="locale"
                :label-for="`title_${locale}`"
                label="Title"
            >
                <InputField
                    v-model="category[locale].title"
                    :required="true"
                    :name="`title_${locale}`"
                    type="text"
                />
            </FormGroup>
            <FormGroup
                label="Parent"
                label-for="parent"
            >
                <AppSelect
                    v-model="category.parent_id"
                    :items="categories"
                />
            </FormGroup>
        </template>
        <template
            v-slot:side
            v-if="!isNew"
        >
            <FormGroup
                v-for="locale in locales"
                :key="`slug_${locale}`"
                :flag="locale"
                :label-for="`slug_${locale}`"
                label="Slug"
            >
                <InputField
                    v-model="category[locale].slug"
                    :required="true"
                    :name="`slug_${locale}`"
                    type="text"
                />
            </FormGroup>
        </template>
    </AppForm>
</template>

<script>
import FormGroup from '../form/FormGroup.vue';
import InputField from '../form/InputField.vue';
import AppSelect from '../form/AppSelect.vue';
import AppForm from '../form/AppForm.vue';
import { get, store, update } from '../../utils/apiHelper';
import { setupTranslation, locales } from '../../utils/translate';

export default {
    components: {
        AppForm,
        FormGroup,
        InputField,
        AppSelect,
    },
    props: {
        heading: {
            type: String,
            required: true,
        },
        isNew: {
            type: Boolean,
            default: true,
        },
        apiBase: {
            type: String,
            required: true,
        },
        urlBase: {
            type: String,
            required: true,
        },
    },
    data: () => ({
        loaded: false,
        loading: false,
        category: {
            title: null,
            parent_id: null,
        },
        categories: [
            { label: 'Choose parent', value: null },
        ],
        locales,
    }),
    computed: {
        currentId() {
            if (this.isNew) return false;

            return Number(this.$route.params.id);
        },
    },
    async created() {
        if (!this.isNew) {
            const category = await get(`/api/${this.apiBase}/${this.currentId}`);
            this.setupForm(category);
        } else {
            this.category = {
                ...this.category,
                ...setupTranslation(this.locales.map(locale => ({
                    locale,
                    title: null,
                }))),
            };
        }

        const categories = await get(`/api/${this.apiBase}`);
        this.setCategorySelect(categories);
        this.loaded = true;
    },
    methods: {
        setupForm(category) {
            this.category = { ...category, ...setupTranslation(category.translations) };
        },
        setCategorySelect(items) {
            const categories = this.getAllCategories(items, 0);
            this.categories = [...this.categories, ...categories];
        },
        getAllCategories(items, step) {
            const indent = '&nbsp;&nbsp;&nbsp;';
            const categories = [];

            items.forEach((category) => {
                if (this.currentId !== category.id) {
                    categories.push({
                        label: `<span class="indent">${indent.repeat(step)}</span>${category.title}`,
                        value: category.id,
                    });
                    if (category.children) {
                        categories.push(...this.getAllCategories(category.children, step + 1));
                    }
                }
            });

            return categories;
        },
        async submitHandler() {
            this.loading = true;

            if (this.isNew) {
                const res = await store(`/api/${this.apiBase}`, this.category);
                if (res) {
                    this.$router.push(this.urlBase);
                }
            } else {
                const res = await update(`/api/${this.apiBase}/${this.currentId}`, this.category);
                if (res) {
                    this.setupForm(res.data.category);
                }
            }

            this.loading = false;
        },
    },
};
</script>

<style lang="postcss" scoped>
</style>
